import { useEffect, useState, memo } from 'react';
import { TooltipStateLess } from './TooltipStateLess';
import type { TooltipStateLessProps } from './TooltipStateLess';

/**
 * The Tooltip Component.
 */
const Tooltip = (
    props: Omit<TooltipStateLessProps, 'open' | 'onOpenChange'> & {
        /**
         * Auto closing tooltip after delay
         */
        autoCloseDelay?: number;
    }
) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (open && props.autoCloseDelay && props.autoCloseDelay > 0) {
            const timeout = setTimeout(() => {
                setOpen(false);
            }, props.autoCloseDelay);
            return () => {
                clearTimeout(timeout);
            };
        }
    }, [open, props.autoCloseDelay]);
    if (props.disabled) {
        return props.children;
    }
    return (
        <TooltipStateLess
            open={open}
            onOpenChange={value => {
                setOpen(value);
            }}
            {...props}
        />
    );
};

export default memo(Tooltip);

export type { TooltipStateLessProps };
export { TooltipStateLess };
